import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';

export interface DeactivateAdvisorCompanyArg {
    id: string;
}

export const DeactivateAdvisorCompany = createAsyncThunk(
    'advisorCompanies/deactivate',
    async (arg: DeactivateAdvisorCompanyArg, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        const response = await axios.post(
            `api/marketplace/advisor-companies/${arg.id}/deactivate`
        );

        if (response.status !== 200) {
            const message =
                response?.response?.data?.title ??
                response?.response?.data?.detail ??
                'An error occurred while deactivating the advisor company.';
            createNotification(message, 'error');
            throw new Error('Failed to deactivate advisor company');
        }

        createNotification('Advisor company deactivated.', 'success');
        return arg.id;
    }
);
